import { Button } from "@/components/ui/button.tsx";
import { X } from "lucide-react";

/**
 * Throws the omnibox overlay away — the visible twin of the Escape handler each
 * overlay card binds for itself. Escape is the whole affordance on a desktop
 * keyboard, but a touch device has none, which leaves a card the user can only
 * answer or walk away from (BIG-7375).
 *
 * Shared by the three overlay cards so dismissal sits in the same corner and
 * reads the same way whichever one the queue is showing.
 */
export const OmniDismissButton = ({
  onDismiss,
  disabled,
  statsigName,
}: {
  onDismiss: () => void;
  /** Locked while a batch commit is in flight, like the pager beside it. */
  disabled?: boolean;
  /** Per-card, so the analytics distinguish which overlay was dismissed. */
  statsigName: string;
}) => (
  <Button
    variant="ghostPopover"
    size="action"
    onClick={onDismiss}
    disabled={disabled}
    aria-label="Dismiss"
    data-statsig-name={statsigName}
  >
    <X className="size-4" />
  </Button>
);
